abstract class Command {

    public abstract execute(version:number, callback:Function, parameter?:number|number[]) : void;

}

export {Command}
